import { makeStyles } from '@material-ui/styles'

export default makeStyles(_ => ({
  container: {
    border: '1px solid #ddd',
    borderRadius: 10,
    height: '35vh',
    width: '25vw',
    margin: 10,
    display: 'flex',
    backgroundImage: (props) => `url("${props.imagePath}")`,
    backgroundRepeat: 'round',
    cursor: 'pointer',
    boxShadow: 'rgba(0, 0, 0, 0.15) 3.6px 3.6px 3.6px',
  },
  containerTitle: {
    borderTop: '1px solid #666',
    padding: 5,
    flexGrow: 1,
    alignSelf: 'end',
    backgroundColor: 'rgba(180, 180, 180, 0.8)',
    borderRadius: '0 0 10px 10px',
  },
  modalImg: {
    height: '60vh',
  },
}))
